import * as React from "react";

import { IconButton, Paper, Close, Typography } from "mpulse-design-system";
import { Grid, Divider, styled } from "@mui/material";

const VersionInfo = ({ showVersionInfo, setShowVersionInfo }) => {
  const { versionInfo } = window;
  const { date, branch, tag, commit, imageHash } = JSON.parse(
    versionInfo.replace(/'/g, '"')
  );

  const handleClose = () => {
    setShowVersionInfo(false);
  };

  return showVersionInfo ? (
    <StyledPaper>
      <StyledIconButton color="tertiary" onClick={handleClose}>
        <Close color="tertiary" />
      </StyledIconButton>
      <Typography
        variant="h4"
        color="secondary"
        sx={{ marginBottom: (theme) => theme.spacing(0.5) }}
      >
        App Version Info
      </Typography>
      <Divider
        sx={{ width: "100%", marginBottom: (theme) => theme.spacing(2) }}
      />
      <Grid container spacing={1}>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="textPrimary">
            <strong>DATE BUILT</strong>:
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="primary">
            {` ${date}`}
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="textPrimary">
            <strong>BRANCH</strong>:
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="primary">
            {` ${branch}`}
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="textPrimary">
            <strong>TAG</strong>:
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="primary">
            {` ${tag}`}
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="textPrimary">
            <strong>COMMIT</strong>:
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="primary">
            {` ${commit}`}
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="textPrimary">
            <strong>IMAGE HASH</strong>:
          </Typography>
        </Grid>
        <Grid item xxs={6}>
          <Typography variant="subtitle2" color="primary">
            {` ${imageHash}`}
          </Typography>
        </Grid>
      </Grid>
    </StyledPaper>
  ) : null;
};

const StyledPaper = styled(Paper)(({ theme }) => ({
    zIndex: 1000,
    width: "220px",
    position: "absolute",
    top: "20vh",
    padding: theme.spacing(4),
  })),
  StyledIconButton = styled(IconButton)(() => ({
    top: "2px",
    right: "2px",
    zIndex: 1001,
    position: "absolute",
  }));

export default VersionInfo;
